import React from 'react'
import Box from '@ui/Box'
import { createBillingPortalSession, useAppSettings, useGetProfile } from '@api/users'
import { formatDistanceToNow, isAfter, isBefore, sub } from 'date-fns'
import { formatDate } from '@utils/format'
import IconButton from '@ui/IconButton'
import { MdInfoOutline } from 'react-icons/md'
import { Color } from '@interfaces/designSystem'
import { useRouter } from 'next/navigation'

const TrialHeaderBanner = () => {
  const router = useRouter()
  const { data } = useGetProfile()
  const { data: appSettings } = useAppSettings()
  const [loading, setLoading] = React.useState(false)

  if (
    data &&
    (data.plan === 'basic' || data.plan === 'pro') &&
    data.monthlySubscriptionStatus === 'trialing' &&
    !data.paymentMethodSet &&
    data.paidAccessDateTime &&
    appSettings?.trialDays
  ) {
    const half = Math.ceil(appSettings.trialDays / 2)
    const needToShow =
      isBefore(new Date(), new Date(data.paidAccessDateTime)) &&
      isAfter(new Date(), sub(new Date(data.paidAccessDateTime), { days: half }))

    if (!needToShow) {
      return null
    }

    return (
      <Box
        fontSize={16}
        bg={Color.Blue_30}
        color={Color.Blue_95}
        p="8px 0"
        textAlign="center"
      >
        <Box style={{ verticalAlign: 'middle' }} display="inline">
          <MdInfoOutline size={20} />
        </Box>
        &nbsp;Your trial ends{' '}
        <strong>
          {formatDistanceToNow(new Date(data.paidAccessDateTime), { addSuffix: true })}
        </strong>{' '}
        ({formatDate(new Date(data.paidAccessDateTime), 'dd MMM')}). Please make sure you
        provided the correct payment details.{' '}
        <IconButton
          containerProps={{ display: 'inline-block', ml: 12 }}
          type="default"
          loading={loading}
          onClick={async () => {
            setLoading(true)

            try {
              const resp = await createBillingPortalSession(undefined, true)
              router.push(resp.data.url)
            } catch (e) {
              setLoading(false)
            }
          }}
        >
          Billing details
        </IconButton>
      </Box>
    )
  }

  return null
}

export default TrialHeaderBanner
